<p-confirmDialog [key]="key" #cd [style]="{ width: '50vw', 'border-radius': '0px', 'background-color': 'white' }" [modal]="true">
    <ng-template pTemplate="footer">
        <ng-content [select]="[dialogFooter]"></ng-content>
    </ng-template>
</p-confirmDialog>